import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import cls from './header-icon-button.module.scss'
import { MaterialIcon } from '~src/new/shared/ui/MaterialIcon/MaterialIcon'

/**
 * Кнопка бургер-меню
 */
export const HeaderBurger = ({ isOpen, onClick, className }) => {
  return (
    <button
      className={classNames(cls.iconButton, className)}
      onClick={onClick}
      type="button"
      aria-label="Меню"
    >
      <MaterialIcon name={isOpen ? 'close' : 'menu'} ariaLabel="Меню" />
    </button>
  )
}

HeaderBurger.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
}
